import { useSelector } from "react-redux";
import { useMovieTrailer } from "../hooks/useMovieTrailer";

export const VideoBackGround = ({ movieId }) => {
  useMovieTrailer(movieId);
  const trailerVideos = useSelector((store) => store?.movies?.trailerVideos);

  return (
    <div className="w-full flex justify-center items-center">
    <iframe
      className="w-full aspect-video"
      src={
        "https://www.youtube.com/embed/" +
        trailerVideos?.[0]?.key +
        "?&autoplay=1&mute=1"
      }
      title="YouTube video player"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    ></iframe>
  </div>
  );
};
